// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e4b6e0dd","208":"c4d5c46d","631":"d4415ec4","774":"717f6bd0","787":"95b0c1cd","820":"5ce26067","910":"c70e707b"}[chunkId] + ".chunk.js";
};